import { BodyText } from 'palette/Typography';

import '../styles/FooterHeader.scss';

export function FooterHeader({ title }) {
    return (
        <BodyText
            className="react-footer-header"
            color="strong"
            level="1"
            weight="bold"
        >
            {title}
        </BodyText>
    );
}
